import React, { FC } from 'react';

import { theme } from 'antd';
import styled from 'styled-components';

const Logo = styled.span<{ $background: string; $color: string; $collapsed: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: ${({ $collapsed }) => ($collapsed ? '32px' : '100%')};
  min-height: 32px;
  padding: ${({ $collapsed }) => ($collapsed ? '6px 0' : '6px 8px')};
  border-radius: 8px;
  background: ${({ $background }) => $background};
  color: ${({ $color }) => $color};
  font-size: 13px;
  font-weight: 700;
  line-height: 20px;
  text-align: center;
  overflow-wrap: anywhere;
`;

interface GeneratedWorkspaceLogoProps {
  title: string;
  collapsed?: boolean;
}

export const GeneratedWorkspaceLogo: FC<GeneratedWorkspaceLogoProps> = ({ title, collapsed = false }) => {
  const { token } = theme.useToken();
  const name = title.trim();
  const label = (collapsed ? Array.from(name).slice(0, 2).join('') : name).toLocaleUpperCase();

  return (
    <Logo $background={token.colorPrimaryBg} $color={token.colorPrimaryText} $collapsed={collapsed} title={name}>
      {label || '•'}
    </Logo>
  );
};
